<template>
  <div class="table-action-wrapper">
    <div class="date-range-group d-flex align-items-center">
      <DatePicker :value="query.date.value" :preset-dates="presetDates" range multi-calendars placeholder="Date Range" @change="changeDate" />
      <Select :options="dateByOptions" placeholder="By Raw" data-title="By" class="has-tip date-picker-left" :value="query.date_by.value" @changeValue="changeDateBy"></Select>
    </div>
    <Select :options="statusOptions" placeholder="Status" data-title="Status" class="has-tip" :value="query?.status?.value" @changeValue="changeStatus"></Select>
    <Select source="user/search" type="auto" field="design.designer_read" placeholder="Designer" :value="query.designer_id.value" @changeValue="changeDesignerId"></Select>
    <Select source="sale-account/search" placeholder="Sale Account" :value="query.account_id.value" @changeValue="changeAccountId"></Select>
    <Select source="user/search" type="auto" field="order.user_read" placeholder="Seller" :value="query.user_ids.value" @changeValue="changeUserId"></Select>
    <Select source="term/search" placeholder="Category" :value="query.term_id.value" @changeValue="changeTermId"></Select>
    <Select :options="freehandDesignOptions" placeholder="Freehand design" data-title="Freehand design" class="has-tip" :value="query.freehand_design.value" @changeValue="changeFreehandDesign"></Select>
    <Select :options="colorBatchOptions" placeholder="Color Batch" data-title="Color Batch" class="has-tip" :value="query.color_batch.value" @changeValue="changeColorBatch"></Select>
    <Select :options="printMethodOptions" placeholder="Print Method" data-title="Print Method" class="has-tip" :value="query.print_method.value" @changeValue="changePrintMethod"></Select>
    <div class="flag-filters">
      <span class="flag-icon" :data-selected="query.flag.value" @click="toggleFlagBox"><i class="ti ti-flag-filled flag"></i></span>
      <ul class="flags" ref="flagsList">
        <li class="radio-container" v-for="(object, flag) in flagOptions" :key="flag"><input type="radio" name="filters[order_flag]" :value="flag" @click="changeFlag" /><span :class="`checkmark choose-flag ${object.color}`"></span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/DatePicker.vue'
import moment from 'moment'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      query: {
        date: {
          value: [],
          valueLabel: '',
          fieldLabel: 'Date Range',
          group: 'date',
          format: '{{ date_by.valueLabel }}: {{ date.valueLabel }}'
        },
        date_by: {
          value: null,
          defaultValue: 'date_created',
          valueLabel: '',
          defaultValueLabel: 'Date Created',
          fieldLabel: 'By',
          group: 'date'
        },
        flag: {
          value: 'all',
          valueLabel: '',
          fieldLabel: 'Flag'
        },
        status: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Status'
        },
        designer_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Designer'
        },
        user_ids: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Seller'
        },
        term_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Category'
        },
        account_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Account'
        },
        freehand_design: {
          value: 'not-include',
          valueLabel: '',
          fieldLabel: 'Freehand Design'
        },
        color_batch: {
          value: '',
          valueLabel: '',
          fieldLabel: 'Color Batch'
        },
        print_method: {
          value: '',
          valueLabel: '',
          fieldLabel: 'Print Method'
        }
      },
      presetDates: ['Today', 'Yesterday', 'This Week', 'Last Week', '7 Days Ago', 'This Month', 'Last Month', '30 Days Ago', '3 Months Ago', '90 Days Ago', 'This Year']
    }
  },
  created() {
    this.query = Object.assign(this.query, this.config?.query)
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    flagOptions() {
      return this.extraAttributes.flags
    },
    dateByOptions() {
      return Object.values(this.extraAttributes?.date_by || [])
    },
    freehandDesignOptions() {
      return Object.values(this.extraAttributes?.freehand_design || [])
    },
    statusOptions() {
      return Object.values(this.extraAttributes?.status || [])
    },
    colorBatchOptions() {
      return Object.values(this.extraAttributes?.color_batches || [])
    },
    printMethodOptions() {
      return Object.values(this.extraAttributes?.print_methods || [])
    }
  },
  methods: {
    changeDate(e) {
      if (e === null) {
        this.query.date = Object.assign(this.query.date, {
          value: null,
          valueLabel: ''
        })
      } else if (_.isArray(e)) {
        this.query.date = Object.assign(this.query.date, {
          value: e.map((item) => moment(item).format('YYYY-MM-DD')),
          valueLabel: e.map((item) => moment(item).format('YYYY/MM/DD')).join(' - ')
        })
      } else {
        return
      }
      this.$emit('change-filters', this.query)
    },
    changeDateBy(value, e) {
      this.query.date_by = Object.assign(this.query.date_by, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeStatus(value, e) {
      this.query.status = Object.assign(this.query.status, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeDesignerId(value, e) {
      this.query.designer_id = Object.assign(this.query.designer_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeAccountId(value, e) {
      this.query.account_id = Object.assign(this.query.account_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeUserId(value, e) {
      this.query.user_ids = Object.assign(this.query.user_ids, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeTermId(value, e) {
      this.query.term_id = Object.assign(this.query.term_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeFreehandDesign(value, e) {
      this.query.freehand_design = Object.assign(this.query.freehand_design, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeColorBatch(value, e) {
      this.query.color_batch = Object.assign(this.query.color_batch, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changePrintMethod(value, e) {
      this.query.print_method = Object.assign(this.query.print_method, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    toggleFlagBox() {
      if (['none', ''].indexOf(this.$refs.flagsList.style.display) != -1) {
        this.$refs.flagsList.style.display = 'flex'
      } else {
        this.$refs.flagsList.style.display = 'none'
      }
    },
    changeFlag(e) {
      this.query.flag = Object.assign(this.query.flag, {
        value: e.currentTarget.value,
        valueLabel: e.currentTarget.value
      })
      this.$refs.flagsList.style.display = 'none'
      this.$emit('change-filters', this.query)
    }
  },
  props: {
    config: Object
  }
}
</script>
